import { render, staticRenderFns } from "./PollStatus.vue?vue&type=template&id=1eda89e6"
import script from "./PollStatus.vue?vue&type=script&lang=ts"
export * from "./PollStatus.vue?vue&type=script&lang=ts"
import style0 from "./PollStatus.vue?vue&type=style&index=0&id=1eda89e6&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports